import * as tslib_1 from "tslib";
import { OnInit, ErrorHandler, EventEmitter } from '@angular/core';
import { WriteReviewComponent } from '../write-review/write-review.component';
import { MatDialog } from '@angular/material';
import { Airport } from '../../airport/models/airport.model';
import { Business } from '../../business/models/business.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { hasTag } from '../../util/tag-utils';
import { EditToggleService } from '../services/edit-toggle.service';
import { AirportService } from '../../airport/airport.service';
import { State } from '../state-view/state.model';
import { MatSnackBar } from '@angular/material';
import { BusinessManagerService } from '../user/business-manager.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { EditReviewResponseComponent } from '../edit-review-response/edit-review-response.component';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import { ReviewReportOffensiveComponent } from '../review-report-offensive/review-report-offensive.component';
import { ReviewMoveComponent } from '../review-move/review-move.component';
import { Router } from '../../../../node_modules/@angular/router';
var ReviewsComponent = /** @class */ (function () {
    function ReviewsComponent(_toggleService, dialog, _auth, _userService, _airportService, _errorHandler, _snackBar, _businessManagerService, _router) {
        var _this = this;
        this._toggleService = _toggleService;
        this.dialog = dialog;
        this._auth = _auth;
        this._userService = _userService;
        this._airportService = _airportService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this._businessManagerService = _businessManagerService;
        this._router = _router;
        this.reloadThisEntity = new EventEmitter();
        this.editModeSet = false;
        this.state = State.Empty;
        this.isFlightDeckAdmin = false;
        this.sortBy = 'likes';
        this.isBusinessManager = false;
        this.isAirportManager = false;
        this.newPhotoIds = [];
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
        this.galleryOptions = [
            {
                width: '341px',
                // height: '255px', // for block with image preview
                height: '80px',
                thumbnailsColumns: 3,
                image: false,
                imageSize: 'contain',
                //  imageAnimation: NgxGalleryAnimation.Slide
                thumbnailsMargin: 5,
                thumbnailMargin: 5,
                imageArrowsAutoHide: true,
                thumbnailsArrowsAutoHide: true,
                previewCloseOnClick: true,
                previewCloseOnEsc: true
            }
        ];
    }
    ReviewsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // Update state based on latest available userInfo, and subscribe to any future
                        // changes to userInfo.
                        this._userInfo = this._userService.userInfo.getValue();
                        if (this._userInfo) {
                            this.recId = Number(this._userInfo.masterCustomerId);
                        }
                        this._userService.userInfo.subscribe(function (u) {
                            // Update userInfo
                            _this._userInfo = u;
                            if (u) {
                                _this.recId = Number(u.masterCustomerId);
                            }
                        });
                        if (!this.business) return [3 /*break*/, 2];
                        this.isFlyingClub = hasTag(this.business.tags, 'Flying Club');
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 1:
                        _a.isBusinessManager = _d.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!this.airport) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._businessManagerService.userManagesAirport(this.airport.airportId)];
                    case 3:
                        _b.isAirportManager = _d.sent();
                        _d.label = 4;
                    case 4:
                        _c = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 5:
                        _c.isFlightDeckAdmin = _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReviewsComponent.prototype.openWriteReview = function () {
        var _this = this;
        if (!this._auth.authenticated || !this._auth.endUser) {
            this._auth.redirectToLogin();
            return;
        }
        this.userReview = this.reviews.find(function (review) { return review.userId === Number(_this._userInfo.masterCustomerId); });
        var dialogRef = this.dialog.open(WriteReviewComponent, {
            // height: '500px',
            data: { airport: this.airport, business: this.business, reviews: this.reviews, userReview: this.userReview,
                reviewSummary: this.reviewSummary, newPhotoIds: this.newPhotoIds }
        });
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.success) {
                // isUpdated.success will be false if there is an error during any of the api calls
                if (isUpdated.businessId > 0) {
                    _this._router.navigateByUrl("/business/" + isUpdated.businessId);
                }
                else {
                    _this.reloadEntity();
                    _this.reloadThisEntity.emit(true);
                }
            }
        });
    };
    ReviewsComponent.prototype.openEditReviewResponseDialog = function (review) {
        var _this = this;
        if (!this._auth.authenticated || !this._auth.endUser) {
            this._auth.redirectToLogin();
            return;
        }
        var entityId;
        var isAirport;
        if (this.airport) {
            isAirport = true;
            entityId = this.airport.airportId;
        }
        else {
            isAirport = false;
            entityId = this.business.id;
        }
        var dialogRef = this.dialog.open(EditReviewResponseComponent, {
            // height: '500px',
            data: { entityId: entityId, reviewId: review.id, isAirport: isAirport, response: review.response }
        });
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.success) {
                // isUpdated.success will be false if there is an error during any of the api calls.
                _this.reloadEntity();
                _this.reloadThisEntity.emit(true);
            }
        });
    };
    Object.defineProperty(ReviewsComponent.prototype, "entityType", {
        get: function () {
            if (this.business && this.isFlyingClub) {
                return 'Flying club';
            }
            if (this.business) {
                return 'Business';
            }
            return 'Airport';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsComponent.prototype, "reviews", {
        get: function () {
            if (this.business) {
                return this.business.reviews;
            }
            else if (this.airport) {
                return this.airport.reviews;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsComponent.prototype, "reviewSummary", {
        get: function () {
            if (this.business) {
                return this.business.reviewSummary;
            }
            else if (this.airport) {
                return this.airport.reviewSummary;
            }
        },
        enumerable: true,
        configurable: true
    });
    ReviewsComponent.prototype.reviewImages = function (review) {
        var tempImages = [];
        review.photos.forEach(function (photo) {
            var tempImage = {
                small: photo.thumbnailPhotoPath,
                medium: photo.previewPhotoPath,
                big: photo.largePhotoPath,
            };
            tempImages.push(tempImage);
        });
        return tempImages;
    };
    ReviewsComponent.prototype.onSortReviewsBy = function (sortBy) {
        this.sortBy = sortBy;
    };
    Object.defineProperty(ReviewsComponent.prototype, "sortedReviews", {
        get: function () {
            if (this.sortBy !== 'likes') {
                // sort by date
                return this.reviews
                    .sort(function (n1, n2) { return n2.addDate.getTime() - n1.addDate.getTime(); });
            }
            else {
                // sort by likes
                return this.reviews
                    .sort(function (n1, n2) {
                    if (n1.interactions.upVotes - n1.interactions.downVotes < n2.interactions.upVotes - n2.interactions.downVotes) {
                        return 1;
                    }
                    if (n1.interactions.upVotes - n1.interactions.downVotes > n2.interactions.upVotes - n2.interactions.downVotes) {
                        return -1;
                    }
                    if (n1.addDate.getTime() < n2.addDate.getTime()) {
                        return 1;
                    }
                    if (n1.addDate.getTime() > n2.addDate.getTime()) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsComponent.prototype, "hasReviewed", {
        get: function () {
            var _this = this;
            if (!this._auth.authenticated || !this._auth.endUser || !this._userInfo) {
                return false;
            }
            return (this.reviews.findIndex(function (review) { return review.userId === Number(_this._userInfo.masterCustomerId); }) > -1);
        },
        enumerable: true,
        configurable: true
    });
    ReviewsComponent.prototype.isMyReview = function (review) {
        if (!this._auth.authenticated || !this._auth.endUser || !this._userInfo) {
            return false;
        }
        return (review.userId === Number(this._userInfo.masterCustomerId));
    };
    ReviewsComponent.prototype.reloadEntity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.business) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        _a.business = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 3:
                        _b.airport = _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReviewsComponent.prototype.reportOffensive = function (isAirport, review) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this._auth.authenticated || !this._auth.endUser) {
                    this._auth.redirectToLogin();
                    return [2 /*return*/];
                }
                dialogRef = this.dialog.open(ReviewReportOffensiveComponent, {
                    width: '550px'
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts, response, response, e_1;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 7];
                                snackBarOpts = { duration: 2000 };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, , 7]);
                                if (!isAirport) return [3 /*break*/, 3];
                                return [4 /*yield*/, this._userService.setAirportInteraction(this.airport.airportId, review.id, 'Offensive')];
                            case 2:
                                response = _a.sent();
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, this._userService.setBusinessInteraction(this.business.id, review.id, 'Offensive')];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                // this._snackBar.open(`Comment reported.`, 'Dismiss', snackBarOpts);
                                this.state = State.Content;
                                this.reloadEntity();
                                this._snackBar.open('Thank you.  Your report has been logged and will be reviewed as soon as possible.', 'Dismiss', { duration: 6000 });
                                return [3 /*break*/, 7];
                            case 6:
                                e_1 = _a.sent();
                                this._snackBar.open('An error occurred saving report. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e_1);
                                // Set state to error, then reset after a few seconds to allow retry.
                                this.state = State.Error;
                                setTimeout(function () {
                                    _this.state = State.Content;
                                }, 2000);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ReviewsComponent.prototype.removeOffensive = function (isAirport, review) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, response, response, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!isAirport) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._userService.setAirportInteraction(this.airport.airportId, review.id, 'ClearOffensive')];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._userService.setBusinessInteraction(this.business.id, review.id, 'ClearOffensive')];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        // this._snackBar.open(`Comment no longer reported.`, 'Dismiss', snackBarOpts);
                        this.state = State.Content;
                        this.reloadEntity();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        this._snackBar.open('An error occurred removing your report. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_2);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ReviewsComponent.prototype.clearOffensive = function (isAirport, review) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, response, response, e_3;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        snackBarOpts = { duration: 2000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!isAirport) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._userService.setAirportInteraction(this.airport.airportId, review.id, 'NotOffensive')];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._userService.setBusinessInteraction(this.business.id, review.id, 'NotOffensive')];
                    case 4:
                        response = _a.sent();
                        _a.label = 5;
                    case 5:
                        // this._snackBar.open(`Comment no longer reported.`, 'Dismiss', snackBarOpts);
                        this.state = State.Content;
                        this.reloadEntity();
                        return [3 /*break*/, 7];
                    case 6:
                        e_3 = _a.sent();
                        this._snackBar.open('An error occurred clearing the user report. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_3);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ReviewsComponent.prototype.deleteReview = function (isAirport, review) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this._auth.authenticated || !this._auth.endUser) {
                    this._auth.redirectToLogin();
                    return [2 /*return*/];
                }
                dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    width: '350px',
                    data: 'Delete this review?'
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts, response, response, e_4;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 7];
                                snackBarOpts = { duration: 2000 };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, , 7]);
                                if (!isAirport) return [3 /*break*/, 3];
                                return [4 /*yield*/, this._userService.deleteAirportReview(this.airport.airportId, review.id)];
                            case 2:
                                response = _a.sent();
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, this._userService.deleteBusinessReview(this.business.id, review.id)];
                            case 4:
                                response = _a.sent();
                                _a.label = 5;
                            case 5:
                                // this._snackBar.open(`Comment no longer reported.`, 'Dismiss', snackBarOpts);
                                this.state = State.Content;
                                this.reloadEntity();
                                return [3 /*break*/, 7];
                            case 6:
                                e_4 = _a.sent();
                                this._snackBar.open('An error occurred deleting the review. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e_4);
                                // Set state to error, then reset after a few seconds to allow retry.
                                this.state = State.Error;
                                setTimeout(function () {
                                    _this.state = State.Content;
                                }, 2000);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ReviewsComponent.prototype.moveReview = function (isAirport, review) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityId, entityType, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this._auth.authenticated || !this._auth.endUser) {
                    this._auth.redirectToLogin();
                    return [2 /*return*/];
                }
                if (this.airport) {
                    entityType = 'Airport';
                    entityId = this.airport.airportId;
                }
                else {
                    entityType = 'Business';
                    entityId = this.business.id;
                }
                dialogRef = this.dialog.open(ReviewMoveComponent, {
                    width: '350px',
                    data: {
                        entityType: entityType,
                        entityId: entityId,
                        reviewId: review.id
                    }
                });
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.success) {
                        // isUpdated.success will be false if there is an error during any of the api calls.
                        _this.reloadEntity();
                        _this.reloadThisEntity.emit(true);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    ReviewsComponent.prototype.checkOverflow = function (elementID) {
        // console.log(elementID);
        var element = document.getElementById(elementID);
        if (element && (element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth)) {
            return true;
        }
        else {
            return false;
        }
    };
    return ReviewsComponent;
}());
export { ReviewsComponent };
